import React from 'react'
import { HistoryContainer, HistoryWrapper, HistoryHeading, HistoryText, HistoryP,
HistorySocial, HistoryImage, Image } from './HistoryElement'
import {FaFacebook, FaInstagram, FaLinkedin} from "react-icons/fa"
import img from "../../Images/book.png"

const History = () => {
    return (
        <HistoryContainer>
            <HistoryWrapper>
                <HistoryText data-aos="fade-left">
                    <HistoryHeading>About Us</HistoryHeading>
                    <HistoryP>Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                             At numquam tempora laboriosam doloremque minima aspernatur. 
                             Quas rerum quis repellendus perspiciatis quisquam excepturi 
                             minima adipisci eveniet impedit corporis aut, sed ex maiores!
                              Fuga ad quasi pariatur possimus sequi unde similique ducimus.</HistoryP>
                        <HistorySocial>
                            <FaFacebook/>
                            <FaInstagram/>
                            <FaLinkedin/>
                        </HistorySocial>
                </HistoryText>
                <HistoryImage data-aos="fade-right">
                    <Image src={img} alt="book"/>
                </HistoryImage>
            </HistoryWrapper>
        </HistoryContainer>
    )
}

export default History
